import { Button, Icon } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';

export const NextDateLabel = ({ label, value }: { label: string; value: string }) => {
  return (
    <S.Wrapper>
      <strong>{label}</strong>

      <NextDateLabelIndicator value={value} />
    </S.Wrapper>
  );
};

export const NextDateLabelIndicator = ({ value, label }: { value: string; label?: string }) => {
  return (
    <S.Button basic color="teal" size="small" icon labelPosition="left" as="div">
      {!label ? (
        <S.Icon name="calendar alternate outline" inverted />
      ) : (
        <S.IndicatorLabel>{label}</S.IndicatorLabel>
      )}
      {value}
    </S.Button>
  );
};

const S = {
  Wrapper: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  Button: styled(Button)`
    &.ui.button {
      cursor: default;
      &.basic.teal:hover {
        color: #00b5ad;
        box-shadow: 0 0 0 1px #00b5ad inset;
      }
    }
  `,
  Icon: styled(Icon)`
    .labeled &&.inverted.icon {
      color: white;
      background-color: #00b5ad;
    }
  `,
  IndicatorLabel: styled.span`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 33px;
    border-top-left-radius: 0.28571429rem;
    border-bottom-left-radius: 0.28571429rem;
    background-color: #00b5ad;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};
